import { createSlice } from '@reduxjs/toolkit';

export const appointmentBooking = createSlice({
  name: 'APPOINTMENT_BOOKING',
  initialState: {}, // comes from preloadedState in the store

  reducers: {
    setPreloadStatus(state, action) {
      return {
        ...state,
        preloadStatus: action.payload?.preloadStatus,
      };
    },
    setShowAppointmentBooking(state, action) {
      return {
        ...state,
        showAppointmentBooking: action.payload?.showAppointmentBooking,
      };
    },
    setWasPreviousPageAppointmentBooking(state, action) {
      return {
        ...state,
        wasPreviousPageAppointmentBooking:
          action.payload?.wasPreviousPageAppointmentBooking,
      };
    },
    setIsNextPageAppointmentBooking(state, action) {
      return {
        ...state,
        isNextPageAppointmentBooking:
          action.payload?.isNextPageAppointmentBooking,
      };
    },
    setSelectedAppointment(state, action) {
      /**
       * Note: it is expected that any generic appointment will have a date and a location (else it's not a appointment!), but the structure of the location object can vary, so we are not enforcing a specific structure for the location object.
       */
      return {
        ...state,
        selectedAppointment: {
          selectedDate: action.payload?.selectedDate,
          selectedLocation: action.payload?.selectedLocation,
          selectedEndDate: action.payload?.selectedEndDate,
        },
      };
    },
    setBookedAppointmentId(state, action) {
      return {
        ...state,
        bookedAppointmentId: action.payload?.bookedAppointmentId,
      };
    },
    setAppointments(state, action) {
      return {
        ...state,
        appointments: action.payload?.appointments,
      };
    },
  },
});

const { actions, reducer } = appointmentBooking;

export const {
  setSelectedAppointment,
  setPreloadStatus,
  setAppointments,
  setBookedAppointmentId,
  setShowAppointmentBooking,
  setWasPreviousPageAppointmentBooking,
  setIsNextPageAppointmentBooking,
} = actions;

export default reducer;
